import React from 'react';
import { Popover as Pover } from 'antd';

/**
 * A popover component
 *
 * {@link https://ant.design/components/popover#api}
 *
 * @module Popover
 * @param {Object} props - the popover props
 * @param {string} [props.content] - the popover content text
 * @param {string} [props.title] - the popover title text
 * @returns {React.ReactElement} - a popover component
**/
const Popover = ( { children, ...props } ) => {
        return (
            <Pover arrow={ { pointAtCenter: true } } { ...props }>
                { children }
            </Pover> );
};

export { Popover };
